<template>
  <div class="page">
    <div class="content">
      <div class="card">
        <div class="row">
          <div class="title">服务卡密码</div>
          <div class="info">{{ careCode }}</div>
        </div>
        <div class="phone" :empty="!phone || phone.length === 0">
          <van-field
            type="text"
            :formatter="formatter"
            v-model="phone"
            placeholder="输入手机号"
          />
        </div>
      </div>
      <div class="u-info">
        <div class="item">
          <div
                  class="phone-brand flex-row flex-between flex-cross-axis-center"
                  @click="showPhoneBrand = true"
          >
            <span class="brand">{{ brand && brand.BrandName }}</span>
            <div class="fill"></div>
            <div class="line"></div>
            <div class="text">选择</div>
            <div class="right-arrow"></div>
          </div>
        </div>
        <div class="item imei">
          <van-field
                  type="number"
                  v-model="imei"
                  placeholder="请输入手机IMEI码"
          />
          <div class="question">
          <span class="type-des" @click="showImei = true"
          >如何获取 &gt;</span
          >
          </div>
        </div>
        <div class="item sn">
          <van-field
                  type="text"
                  :formatter="formatter"
                  v-model="sn"
                  placeholder="请输入手机序列号码"
          />
          <div class="question">
          <span class="type-des" @click="checkSn"
          >如何获取 &gt;</span
          >
          </div>
        </div>
      </div>
      <div class="agreement">
        <span>激活服务表示您已同意</span>
        <span @click="gotoAgreement">《品胜无忧卡服务用户协议》</span>
      </div>
      <div class="bottom">
        <div class="btn">
          <y-button @click="submit">确认提交</y-button>
        </div>
      </div>
    </div>
    <phone-brand-dialog
      v-model="showPhoneBrand"
      @callback="closeBrandDialog"
      @select="select"
    />
    <imei-dialog v-model="showImei"></imei-dialog>
  </div>
</template>

<script>
import { httpOpen } from "../../scripts/network";
import { login } from "../../scripts/auth";
import Vue from "vue";
import { Field, Uploader } from "vant";
// import { getAgreementUrl } from "../../scripts/care_agreement";
Vue.use(Uploader);
Vue.use(Field);
export default {
  name: "CareActive",
  data() {
    return {
      showPhoneBrand: false,
      showImei: false,
      phone: "",
      careCode: "",
      imei: "",
      sn: "",
      brand: "",
      type: -1,
      filtList: [],
      name: "",
    };
  },
  computed: {
    isMustInputSn() {
      return this.brand && this.brand.BrandName.toUpperCase() == "APPLE";
    },
  },
  mounted() {
    // alert()
    this.phone = this.$store.state.userInfo && this.$store.state.userInfo.phone;
    if (!this.phone) {
      login(this.$store, this.$router);
      return;
    }
    this.careCode = this.$route.params.code;
    this.type = this.$route.params.type;
    this.name = this.$route.query.name;
    this.loadFromCache(this.careCode);
  },
  methods: {
    checkSn() {
      this.saveInputCache();
      this.goto("/checksn?brand=" + (this.brand && this.brand.BrandName));
    },
    formatter(value) {
      return value.replace(/[^\w]/g, "");
    },
    loadFromCache(code) {
      const cache = window.session.get("active#" + code);
      if (cache) {
        this.sn = cache.sn;
        this.imei = cache.imei;
        this.brand = cache.brand;
      }
    },
    saveInputCache() {
      const cache = {
        sn: this.sn,
        imei: this.imei,
        brand: this.brand,
      };
      window.session.save("active#" + this.careCode, cache);
    },
    dataBase64toBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    async uploadImage() {
      try {
        if (!this.filtList || this.filtList.length === 0) {
          return;
        }
        let img = this.filtList[0].content;
        let formData = new FormData();
        const data = this.dataBase64toBlob(img);
        formData.append("file", data);
        const ret = await httpOpen("/Common/ImageFileUpload", {
          type: "POST",
          timeout: 90000,
          body: formData,
        });
        if (ret.Status) {
          return ret.Data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    beforeRead(file) {
      if (file.size >= 1024 * 1024 * 10) {
        this.$toast("图片太大");
        return false;
      }
      return true;
    },
    select(e) {
      this.brand = e.brand;
      this.closeBrandDialog(false);
    },
    closeBrandDialog(e) {
      this.showPhoneBrand = e.dialog;
    },
    async submit() {
      if (!this.phone || this.phone.length === 0) {
        this.$toast("请输入手机号码");
        return;
      }
      if (!this.imei || this.imei.length === 0) {
        this.$toast("请输入IMEI码");
        return;
      }
      if (!this.sn || this.sn.length === 0) {
        this.$toast("请输入手机序列号");
        return;
      }
      if (!this.brand || this.brand.BrandName.length === 0) {
        this.$toast("请选择手机型号");
        return;
      }

      this.$router.push({
        name: "ActiveStepsManager",
        params: {
          code: this.careCode,
        },
        query: {
          imei: this.imei,
          sn: this.sn,
          brand: this.brand.BrandName,
          phone: this.phone,
          name: this.name,
        },
      });
      // try {
      //   this.$loading.show("请等待");
      //   const ret = await httpOpen("/WuYouCard/ActivationWfcOrder", {
      //     type: "post",
      //     body: {
      //       ActivationCode: this.careCode,
      //       IMEICode: this.imei,
      //       SerialNumber: this.sn,
      //       BrandName: this.brand.BrandName,
      //       MobilePhone: this.phone
      //     },
      //   });
      //   this.$loading.hide();
      //   if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
      //     this.saveInputCache();
      //     login(this.$store, this.$router);
      //     return;
      //   } else if (ret.Status) {
      //     const id = ret.Data.SysNo;
      //     this.$toast("激活成功");
      //     this.$router.replace("/care/active/" + id + "/submit-success");
      //   } else {
      //     this.$toast(ret.Message);
      //   }
      // } catch (e) {
      //   console.log(e);
      //   this.$loading.hide();
      // }
    },
    async gotoAgreement() {
      // this.$loading.show("请稍后");
      // const url = await getAgreementUrl(null, this.careCode, this.type);
      // this.$loading.hide();
      // this.goto(url);
      this.saveInputCache();
      this.goto(`/agreement?code=${this.careCode}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row {
  display: flex;
  flex-direction: row;
}
.page {
  min-height: 100vh;
  padding-bottom: 83px;
  overflow: unset;
}
.content {
  position: absolute;
  z-index: 1;
  top: 0;
  width: 100%;
  background: #F5F5F5 url("~@/assets/card-active-bg.png") 0 0 no-repeat;
  background-size: 100%;
  padding-top: 77%;
}
.card {
  border-radius: 6px;
  background: white;
  margin: 0 16px 0 16px;
  padding: 16px;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.14);
}
.card .row {
  justify-content: space-between;
}
.row .title {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
.row .info {
  color: black;
  font-size: 16px;
  font-weight: bold;
}
.phone {
  position: relative;
}
.phone::after {
  content: "（将领取无忧卡）";
  position: absolute;
  right: 0;
  bottom: 4px;
  color: #666666;
  font-size: 12px;
  padding: 11px 10px;
}
.phone[empty="true"]::after {
  content: "（该手机号将领取无忧卡） ";
  color: #666666;
  font-size: 12px;
  padding: 11px 10px;
}
.phone >>>input{
  font-size: 18px !important;
}
.content >>>input{
  padding: 11px 10px;
  font-size: 14px;
}
.content >>>input::placeholder{
  color: #000;
  font-weight: 600;
}
.u-info{
  border-radius: 6px;
  background-color: #fff;
  margin: 9px 18px;
  padding: 15px;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item .question{
  width: 120px;
  text-align: right;
}
.card + .item {
  margin-top: 20px;
}
.item + .item {
  margin-top: 8px;
}
.bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 10px 20px;
}
.type-content {
  font-size: 16px;
  font-weight: 500;
  margin-top: 6px;
}

.type-des {
  font-size: 13px;
  color: #C28954;
  margin-left: 8px;
}

.phone-brand {
  border-radius: 4px;
  padding: 15px 16px;
  background-color: #f5f5f5;
  font-size: 14px;
  margin-top: 6px;
  min-height: 22px;
  width: 100%;
  color: #323233;
}
.fill {
  flex: 1 1;
}
.phone-brand .text {
  margin: 0 12px;
}
.phone-brand .line {
  height: 18px;
  width: 1px;
  background: #e4e4e4;
}
.brand:empty::before {
  content: "请选择手机品牌";
  color: #000;
  font-weight: 600;
  font-size: 14px;
}
.right-arrow {
  border-top: 6px solid #000;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  width: 0;
  height: 0;
}
.phone-brand:active .right-arrow {
  filter: opacity(0.6);
}

.imei input,
.sn input {
  box-sizing: border-box;
  width: 100%;
  border-radius: 3px;
  background-color: #f5f5f5;
  padding: 6px;
}

.van-field {
  font-size: 16px;
  font-weight: 500;
  margin-top: 6px;
  padding: 4px 6px !important;
  border-radius: 3px;
  background-color: #f5f5f5;
  padding: 6px;
}

.uploader {
  margin: 13px 0 90px;
}

.van-uploader >>> .van-uploader__upload-icon {
  font-size: 32px;
}

.van-uploader >>> .van-uploader__upload {
  width: 68px;
  height: 68px;
  border-radius: 3px;
  background: rgba(245, 245, 245, 1);
  border-color: rgba(245, 245, 245, 1);
}

.van-uploader >>> .van-uploader__preview-image {
  width: 68px;
  height: 68px;
}

.agreement {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
}

.agreement span:first-child {
  color: #333;
}

.agreement span:last-child {
  color: #ff7a3e;
}
</style>
